window.variantChanged = false;
window.translationsText = window.translationsText || {};
window.translationsText.stickyFilled = 'Visualizza la selezione dei colori';
window.translationsText.farbe = 'Kleur';
window.translationsText.design = 'Design';

window.translationsText.buttonUnfilled = 'Kies je Designs';
window.translationsText.optionale = 'Optioneel Design';
if ($('body').hasClass('set_starter_new_dip') || $('body').hasClass('set_refil_new_dip')) {
    window.translationsText.design = 'Kleur';
      window.translationsText.buttonUnfilled = 'Kies je Kleur';
     window.translationsText.optionale = 'Optioneel Kleur';
}

// $(window).on('load', function() {
//     function checkPremiumSelect() {
//         $('.block-swatch.custom-po-set').each(function() {
//             let text = $(this).find('input').val();
//             if (text && (text.includes('Premium') || text.includes('premium') || text.includes('5'))) {
//                 $(this).find('input').trigger('click'); 
//             }
//         });
//     }
    
//     function intervalCheckSelect() {
//         if (window.location.href.includes("variant=")) {
//             let checkedValue = $('.custom-po-set .block-swatch__radio:checked').val();
//             if (checkedValue && (checkedValue.includes('Premium') || checkedValue.includes('premium') || checkedValue.includes('5'))) {
//                     $('.block-swatch.custom-po-set').each(function() {
//                         $(this).css('pointer-events', 'unset');
//                         $(this).find('.block-swatch__item').css('cursor', 'pointer');
//                     });
//                 $('.custom-po-set .block-swatch__radio:checked').trigger('click');
//                 clearInterval(intervalIdSelect);
//             } else {
//                 checkPremiumSelect();
//             }
//         } else {
//             checkPremiumSelect();
//         }
//     }
    
//     let intervalIdSelect = setInterval(intervalCheckSelect, 200);
// });

$(document).ready(function() {

  
  $('body').on('click', '.manikure_filter', function(e) {
    e.preventDefault();
    $('.tag-wrapper.active').click();
    if ($(this).hasClass('active_filter')) {
    $('.manikure_pedikure_filter span').removeClass('active_filter');
    $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
      $(this).show();
    })
    } else {
    $('.manikure_pedikure_filter span').removeClass('active_filter')
    $(this).addClass("active_filter");
    $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
      if ($(this).hasClass('pfilter_pedikure')) {
        $(this).hide();
      } else {
        $(this).show();
      }
    })
    }
  })
  
  
  $('body').on('click', '.pedikure_filter', function(e) {
    e.preventDefault();
    $('.tag-wrapper.active').click();
    if ($(this).hasClass('active_filter')) {
    $('.manikure_pedikure_filter span').removeClass('active_filter');
    $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
      $(this).show();
    })
    } else {
    $('.manikure_pedikure_filter span').removeClass('active_filter')
    $(this).addClass("active_filter");
    $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
      if (!$(this).hasClass('pfilter_pedikure')) {
        $(this).hide();
      } else {
        $(this).show();
      }
    })
    }
  })

  

  $('body').on('click', '.color_selecor_drawer', function(e) {
        $('html, body').animate({
          scrollTop: $('#pick-color-id').offset().top - 100
        }, 100);
        $('color-switcher.color-selection__image.required-switcher.readytoselect').trigger('click');
    });
  
    // var $span = $('<span class="Premium_text_top">Più popolari!</span>');
    // var $target = $('.block-swatch.custom-po-set:nth-child(2)');
    // $target.prepend($span);

      $('.block-swatch.custom-po-set').each(function () {
        let text = $(this).find('.block-swatch__item').text();
        if (text.includes('Premium') || text.includes('premium')) {
          $(this).prepend($('<span class="Premium_text_top">Più popolari!</span>'));
        }
     })

    
      $('body').on('click', '.whats-in-set[aria-controls="whats-in-set"]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).attr("aria-expanded", "true");
        $('html').addClass('lock-all');
        $('whats-in-set#whats-in-set').attr('open', '')
    })

    
          $('body').on('click', "whats-in-set#whats-in-set .popup-close", function(e) {
        $('.whats-in-set[aria-controls="whats-in-set"]').attr("aria-expanded", "false");
        $('whats-in-set#whats-in-set').removeAttr('open');
        $('html').removeClass('lock-all');
    });

    $('body').on('click', 'color-switcher.color-selection__image', function(e) {
        e.preventDefault();
          if (!$("body").hasClass("color_ab_test")) {
              $('color-switcher.color-selection__image').each(function() {
                  $(this).attr("aria-expanded", "false");
                  $(this).closest('.color-selection__grid-item').removeClass('active');
              })
      
              if ($(this).hasClass('coladded')) {
                  $(this).closest('.color-selection__grid-item').addClass('active');
                  $(this).attr("aria-expanded", "true");
              } else {
                  $('color-switcher.color-selection__image.readytoselect').closest('.color-selection__grid-item').addClass('active');
                  $('color-switcher.color-selection__image.readytoselect').attr("aria-expanded", "true");
              }
      
              $('html').addClass('lock-all');
              $(`color-choose-drawer#${$(this).attr('aria-controls')}`).attr('open', '');
            
          } else {
            
            if ($(this).hasClass('coladded')) {
                // $(this).closest('.color-selection__grid-item').addClass('active');
                // $(this).attr("aria-expanded", "true");
            } else {
              
                $('color-switcher.color-selection__image').each(function() {
                    $(this).attr("aria-expanded", "false");
                    $(this).closest('.color-selection__grid-item').removeClass('active');
                })
              
                $('color-switcher.color-selection__image.readytoselect').closest('.color-selection__grid-item').addClass('active');
                $('color-switcher.color-selection__image.readytoselect').attr("aria-expanded", "true");
    
                $('html').addClass('lock-all');
              $(`color-choose-drawer#${$(this).attr('aria-controls')}`).attr('open', '');
              
            }
          }

    });


const currentUrl = window.location.href;
const decodedUrl = decodeURIComponent(currentUrl);
const urlParams = new URLSearchParams(decodedUrl.split('?')[1]);
const freeVariants = urlParams.get('free_ids')?.split(',') || [];
const discountedVariants = urlParams.get('optional_ids')?.split(',') || [];
const filteredFreeVariants = freeVariants.filter(Boolean);
const filteredDiscountedVariants = discountedVariants.filter(Boolean);
const setId = urlParams.get('set_id');
  
let urlParts = currentUrl.split('&optional_ids');
if (filteredFreeVariants && filteredFreeVariants.length > 0) {
   urlParts = currentUrl.split('&free_ids');
} 
const newUrl = urlParts[0];
console.log('newUrl', newUrl) 
window.history.replaceState(null, document.title, newUrl);

  
function processVariants(variants, selector, delay) {
  return new Promise((resolve) => {
    let completedIterations = 0;

    $.each(variants, function (index, value) {
      setTimeout(() => {
        if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          $(`${selector}:not(.coladded)`)
          .first()
          .attr("aria-expanded", "true");
        } else {
          $(`${selector}[aria-expanded="false"]:not(.coladded)`)
          .first()
          .attr("aria-expanded", "true");
        }

        $(`color-choose-drawer#color-choose-drawer .product-tile-item[data-variant='${value}']`)
          .trigger("click");

        // Increment the counter and check if all iterations are complete
        completedIterations++;
        if (completedIterations === variants.length) {
          resolve(); // Resolve the promise once all iterations are done
        }
      }, delay);
    });
  });
}


if (filteredFreeVariants && filteredFreeVariants.length > 0) {
  processVariants(filteredFreeVariants, '#pick-color-id color-switcher.color-selection__image', 200)
  .then(() => {
    if (filteredDiscountedVariants && filteredDiscountedVariants.length > 0) {
      return processVariants(filteredDiscountedVariants, '#pick-color-id color-switcher.color-selection__image.optional-switcher', 200);
    } else {
      return true;
    }
  })
  .then(() => {
    $('form button.inventory-product[data-product-add-to-cart-button]').attr('set-id', setId);
    $('form button.inventory-product[data-product-add-to-cart-button]').addClass('updateProduct');
  });
} else if (filteredDiscountedVariants && filteredDiscountedVariants.length > 0) {
  processVariants(filteredDiscountedVariants, '#pick-color-id color-switcher.color-selection__image', 200)
  .then(() => {
    $('form button.inventory-product[data-product-add-to-cart-button]').attr('set-id', setId);
    $('form button.inventory-product[data-product-add-to-cart-button]').addClass('updateProduct');
  });
}



document.addEventListener('variant:changed', function(event) {  
  let eventVariant = event.detail.variant;
  window.variantChanged = false;
  let isColorArray = false;
  let isVariantsArray = false;
  let pre_color_array;
  let preSetId;

  if ($('.color_selected_main .selected_item.coladded').length > 0) {
     $('.color_selected_main .selected_item.coladded').css('backgroundImage', `url(https://www.doonails.com/cdn/shop/files/new-nail-bg.png?v=1696294386)`);
     $('.color_selected_main .selected_item.coladded').removeClass('coladded');
     $('.color_selected_main .selected_item.coladded').removeAttr('variant-id');
  }

  // If we're in the "single products" flow, grab the existing color-array
  if ($('.inventory-product').hasClass('updateSingleProducts')) {
    pre_color_array = $('.inventory-product').attr('color-array');
    isColorArray = true;
  }

  // Collect all selected variant IDs
  const selectedVariantsArray = [];
  let totalColors = parseInt($(`variant-metacolor input[value="${eventVariant.id}"]`).attr('data-free-colors'));
  if ($(`variant-metacolor input[value="${eventVariant.id}"]`).attr('data-optional-colors')) {
    totalColors = totalColors + parseInt($(`variant-metacolor input[value="${eventVariant.id}"]`).attr('data-optional-colors'));
  }
  
  $('color-switcher.color-selection__image.coladded').each(function (index) {
    if (totalColors > index) {
      selectedVariantsArray.push($(this).attr('variant-id'));      
    }    
  });

  // If we're in the "set" flow, grab the existing set-id
  if ($('.inventory-product').hasClass('updateProduct')) {
    preSetId = $('.inventory-product').attr('set-id');
    isVariantsArray = true;
  }

  processVariants(selectedVariantsArray, '#pick-color-id color-switcher.color-selection__image', 200)
    .then(() => {
      if (isVariantsArray) {
        $('form button.inventory-product[data-product-add-to-cart-button]')
          .attr('set-id', preSetId)
          .addClass('updateProduct');
      }
      return true;
    })
    .then(() => {
      if (isColorArray) {
        $('form button.inventory-product[data-product-add-to-cart-button]')
          .attr('color-array', pre_color_array)
          .addClass('updateSingleProducts');
      }
      return true;
    })
    .then(() => {
      window.variantChanged = true;
      return true;
    });
});

const singleVariants = urlParams.get('single_colors')?.split(',') || [];
const filteredSingleVariants = singleVariants.filter(Boolean);  
const urlSingleParts = decodedUrl.split('&single_colors');
const newSingleUrl = urlSingleParts[0];
window.history.replaceState(null, '', newSingleUrl);

let singleVariantsArray = [];
let singleVariantsString = '';
filteredSingleVariants.forEach((item) => {
  let itemParts = item.split(':');
  if (singleVariantsString != '') {
    singleVariantsString = singleVariantsString + ',' + item;
  } else {
    singleVariantsString = item;
  }
  singleVariantsArray.push(itemParts[0]);
});

if (singleVariantsArray.length > 0) {
  processVariants(singleVariantsArray, '#pick-color-id color-switcher.color-selection__image', 200)
  .then(() => {
    $('form button.inventory-product[data-product-add-to-cart-button]').attr('color-array', singleVariantsString);
    $('form button.inventory-product[data-product-add-to-cart-button]').addClass('updateSingleProducts');
    return true;
  });
}

  

  $("body").on("click", "color-choose-drawer .product-tile-item", function(e) {
    var target = $(e.target);
    const $this = $(this);
    
    if (!target.hasClass('dot') 
      && !target.hasClass('flickity-page-dot') 
      && !target.hasClass('quantity_minus') 
      && !target.hasClass('flickity-button') 
      && !target.hasClass('flickity-page-dots') 
      && !target.hasClass('flickity-button-icon')
      && !target.hasClass('color_zoom_popup')
      && !target.hasClass('color_zoom_popup_svg')) {

      
        const girdSlider = document.querySelector('.color-selection__grid.selection_grid_slider');
        if (girdSlider) {
          const existing = Flickity.data(girdSlider);
          if (existing) {
            existing.destroy();
          }
        }

      
        let markFarbe = $('color-switcher.color-selection__image[aria-expanded="true"]');
        let colorImage = $(this).attr("data-file");
        let colorName = $(this).attr("data-name");
        let vendorName = $(this).attr("data-vendor");
        let variantId = $(this).attr("data-variant");
        let colorPriceVal = parseFloat($this.attr("data-price")) || 0;


        var count = markFarbe.closest('.color-selection__grid-item').attr('data-count');
       
        markFarbe.attr('variant-name', colorName);
        markFarbe.attr('variant-id', variantId);
        markFarbe.attr('variant-img', colorImage);
        markFarbe.attr('data-original-price', colorPriceVal);
          
        markFarbe.css('backgroundImage', `url(${colorImage})`);
        markFarbe.siblings('.farbe-title').text(colorName);
        markFarbe.siblings('.farbe-vendor').text(vendorName);
        markFarbe.addClass('coladded');
        markFarbe.closest('.color-selection__grid-item').addClass('coladded');
        markFarbe.removeClass('readytoselect');

        if ($('#pick-color-id').attr('data-required-off') && $('#pick-color-id').attr('data-required-off') != '0') {
          let discountPercent = parseFloat($('#pick-color-id').attr('data-required-off')) || 0;
          let discountedPrice = colorPriceVal * (1 - discountPercent / 100);
          let finalPrice = discountedPrice;        
          markFarbe.attr('data-price', finalPrice);
          markFarbe.attr('data-percent', discountPercent);
          markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPrice));
          markFarbe.attr('data-compare', colorPriceVal);
          markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));
        }
      
        if (markFarbe.hasClass('optional-switcher')) {   
          
            let discountPercentOptional = parseFloat($('#pick-color-id').attr('data-optional-off')) || 0;
            let discountedPriceOptional = colorPriceVal * (1 - (discountPercentOptional / 100));
            let finalPriceOptional = discountedPriceOptional;
          
            markFarbe.attr('data-price', finalPriceOptional);
            markFarbe.attr('data-percent', discountPercentOptional);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPriceOptional));
            markFarbe.attr('data-compare', colorPriceVal);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));         

            var countTotal = parseInt(markFarbe.closest('#pick-color-id').attr('data-total-colors'));
            var basicCount = $('#pick-color-id .color-selection__grid-item').length;
            var dataPercent = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-off'));
            var countTotalOptional = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-colors'));
            let countOptional = $('.color-selection__grid-item.optional-switcher.coladded').length;
          
            let countOptionalUnselected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
          
            if ((countOptional < countTotalOptional) && countOptionalUnselected == 0 && countTotalOptional > 0) {
              
                let newItemHtml = `<div class="color-selection__grid-item optional-switcher" data-percent="${dataPercent}" data-count="${basicCount+1}" data-optional-count="${countTotalOptional}" data-total-count="${countTotal}">
                   <span class="discounted_percent">-${dataPercent}%</span>
                   <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${basicCount+1}" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
                      <button class="remove_item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                   </color-switcher>
                   <div class="farbe-title">${window.translationsText.optionale}</div>
                   <div class="farbe-vendor"></div>
                   <div class="farbe-price_wrapper">
                      <div class="farbe-price"></div>
                      <div class="farbe-compare"></div>
                   </div>
                </div>`;
              
              $('.color-selection__container .color-selection__grid').children().last().after(newItemHtml);

            }

        }
      

        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
          
        if (!$("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          $('color-choose-drawer#color-choose-drawer').removeAttr('open');
          $('html').removeClass('lock-all');
        }
          
        $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded').length);

        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('active');
      
        updateCounter();
          
        let colorNameSelected = $('color-switcher.color-selection__image.coladded').last().attr('variant-name');
        $('.rosegold_inner').show();
        $('.rosegold_heading p').html(`${colorName} succesvol geselecteerd`);
        $('.design_combinations_inner').hide();
        $('.press_nail_inner').show();


      if ($('.color-selection__grid-item.required-switcher:not(.coladded)').length <= 0) {
          $('.color-selection__grid-item.optional-switcher').show();
        } else if ($('.color-selection__grid-item.required-switcher:not(.coladded)').length > 0 && $('.color-selection__grid-item.optional-switcher.coladded').length <= 0) {
          $('.color-selection__grid-item.optional-switcher').first().hide();
        }
      
        if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          updateColorDrawerSlider();
          colorSelectionSlider();
          // $this.addClass('active');
          $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().attr("aria-expanded", "true");
          // $('.color_selected_main .selected_item:not(.coladded)').first().css('backgroundImage', `url(${colorImage})`);
          // $('.color_selected_main .selected_item:not(.coladded)').first().attr('variant-id', variantId);
          // $('.color_selected_main .selected_item:not(.coladded)').first().addClass('coladded');
        }
      
      }

    });



  function upgradeVariantAfter($this) {
    const variantPoller = setInterval(() => {
      if (window.variantChanged === true) {
        clearInterval(variantPoller);

        let markFarbe = $('color-switcher.color-selection__image[aria-expanded="true"]');
        let colorImage = $this.attr("data-file");
        let colorName = $this.attr("data-name");
        let vendorName = $this.attr("data-vendor");
        let variantId = $this.attr("data-variant");
        let colorPriceVal = parseFloat($this.attr("data-price")) || 0;


        var count = markFarbe.closest('.color-selection__grid-item').attr('data-count');
       
        markFarbe.attr('variant-name', colorName);
        markFarbe.attr('variant-id', variantId);
        markFarbe.attr('variant-img', colorImage);
        markFarbe.attr('data-original-price', colorPriceVal);
          
        markFarbe.css('backgroundImage', `url(${colorImage})`);
        markFarbe.siblings('.farbe-title').text(colorName);
        markFarbe.siblings('.farbe-vendor').text(vendorName);
        markFarbe.addClass('coladded');
        markFarbe.closest('.color-selection__grid-item').addClass('coladded');
        markFarbe.removeClass('readytoselect');

        if ($('#pick-color-id').attr('data-required-off') && $('#pick-color-id').attr('data-required-off') != '0') {
          let discountPercent = parseFloat($('#pick-color-id').attr('data-required-off')) || 0;
          let discountedPrice = colorPriceVal * (1 - discountPercent / 100);
          let finalPrice = discountedPrice;        
          markFarbe.attr('data-price', finalPrice);
          markFarbe.attr('data-percent', discountPercent);
          markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPrice));
          markFarbe.attr('data-compare', colorPriceVal);
          markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));
        }
      
        if (markFarbe.hasClass('optional-switcher')) {   
          
            let discountPercentOptional = parseFloat($('#pick-color-id').attr('data-optional-off')) || 0;
            let discountedPriceOptional = colorPriceVal * (1 - (discountPercentOptional / 100));
            let finalPriceOptional = discountedPriceOptional;
            console.log('finalPriceOptional', finalPriceOptional)
          
            markFarbe.attr('data-price', finalPriceOptional);
            markFarbe.attr('data-percent', discountPercentOptional);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPriceOptional));
            markFarbe.attr('data-compare', colorPriceVal);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));         

            var countTotal = parseInt(markFarbe.closest('#pick-color-id').attr('data-total-colors'));
            var basicCount = $('#pick-color-id .color-selection__grid-item').length;
            var dataPercent = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-off'));
            var countTotalOptional = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-colors'));
            let countOptional = $('.color-selection__grid-item.optional-switcher.coladded').length;
          
            let countOptionalUnselected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
          
            if ((countOptional < countTotalOptional) && countOptionalUnselected == 0 && countTotalOptional > 0) {
              
                let newItemHtml = `<div class="color-selection__grid-item optional-switcher" data-percent="${dataPercent}" data-count="${basicCount+1}" data-optional-count="${countTotalOptional}" data-total-count="${countTotal}">
                   <span class="discounted_percent">-${dataPercent}%</span>
                   <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${basicCount+1}" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
                      <button class="remove_item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                   </color-switcher>
                   <div class="farbe-title">${window.translationsText.optionale}</div>
                   <div class="farbe-vendor"></div>
                   <div class="farbe-price_wrapper">
                      <div class="farbe-price"></div>
                      <div class="farbe-compare"></div>
                   </div>
                </div>`;
              
              $('.color-selection__container .color-selection__grid').children().last().after(newItemHtml);

            }

        }
        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
          
        if (!$("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          $('color-choose-drawer#color-choose-drawer').removeAttr('open');
          $('html').removeClass('lock-all');
        }
          
        $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded').length);

        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('active');
      
        updateCounter();
          
        let colorNameSelected = $('color-switcher.color-selection__image.coladded').last().attr('variant-name');
        $('.rosegold_inner').show();
        $('.rosegold_heading p').html(`${colorName} succesvol geselecteerd`);
        $('.design_combinations_inner').hide();
        $('.press_nail_inner').show();

        if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          updateColorDrawerSlider();
          colorSelectionSlider();
          // $this.addClass('active');
          $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().attr("aria-expanded", "true");
          // $('.color_selected_main .selected_item:not(.coladded)').first().css('backgroundImage', `url(${colorImage})`);
          // $('.color_selected_main .selected_item:not(.coladded)').first().attr('variant-id', variantId);
          // $('.color_selected_main .selected_item:not(.coladded)').first().addClass('coladded');
        }
      }
    }, 200);
  }


    $('body').on('click', 'color-switcher.color-selection__image .remove_item', function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.stopPropagation();
        var $parent = $(this).parents('.color-selection__grid-item');
        $parent.removeClass('coladded');
        var count = parseInt($parent.attr('data-count'));
        var totalCount = parseInt($parent.attr('data-total-count'));
        var $img = $parent.children('.color-selection__image--top');
        $parent.children('.color-selection__image').removeAttr('data-price');
        $parent.children('.color-selection__image').removeAttr('data-compare');
        $parent.children('.farbe-price_wrapper').find('.farbe-price').html('');
        $parent.children('.farbe-price_wrapper').find('.farbe-compare').html('');
        if ($parent.hasClass('optional-switcher')) {
            var countTotal = parseInt($parent.attr('data-total-count'));
            $parent.children('.farbe-title').text(`${window.translationsText.optionale}`);
            var visibleCount = $('.color-selection__grid-item.optional-switcher').length;

            if (visibleCount > 1) {
                $parent.remove();

                  let indexerOptional = parseInt($('#pick-color-id').attr('data-free-colors'));
                  let firstOptional = indexerOptional + 1;
                  $('.color-selection__grid-item.optional-switcher').each(function (index) {
                    indexerOptional += 1;
                    $(this).attr('data-count', indexerOptional);
                  })
                  let indexerOptionalCounter = indexerOptional + 1;
              
                  var countTotal = parseInt($('#pick-color-id').attr('data-total-colors'));
                  var dataPercent = parseInt($('#pick-color-id').attr('data-optional-off'));
                  var countTotalOptional = parseInt($('#pick-color-id').attr('data-optional-colors'));
                  let countOptional = $('.color-selection__grid-item.optional-switcher.coladded').length;

                
                  let countOptionalUnselected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
                
                  if ((countOptional < countTotalOptional) && countOptionalUnselected == 0 && countTotalOptional > 0) {
                      let newItemHtml = `<div class="color-selection__grid-item optional-switcher" data-percent="${dataPercent}" data-count="${indexerOptionalCounter}" data-optional-count="${countTotalOptional}" data-total-count="${countTotal}">
                         <span class="discounted_percent">-${dataPercent}%</span>
                         <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${indexerOptionalCounter}" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
                            <button class="remove_item">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                              <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </button>
                         </color-switcher>
                         <div class="farbe-title">${window.translationsText.optionale}</div>
                         <div class="farbe-vendor"></div>
                         <div class="farbe-price_wrapper">
                            <div class="farbe-price"></div>
                            <div class="farbe-compare"></div>
                         </div>
                      </div>`;
                    
                    $('.color-selection__container .color-selection__grid').children().last().after(newItemHtml);
      
                  }
            } else {
                $(`.color-selection__grid-item.optional-switcher[data-count="${count}"]`).children('.color-selection__image').addClass('readytoselect')
            }
          
        } else {
            $(`.color-selection__grid-item[data-count=${count}]`).children('.farbe-title').text(`${window.translationsText.design} ${count}`);
        }
        $(`.color-selection__grid-item[data-count=${count}]`).children('.farbe-vendor').text('');

        $parent.children('.color-selection__image').removeAttr('variant-name');
        $parent.children('.color-selection__image').removeAttr('variant-id');
        $parent.children('.color-selection__image').removeAttr('variant-img');
        $img.removeAttr('style');
        $img.removeClass('coladded');
        $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded:not(.disabled-color)').length);

        

        $('.color-selection__grid-item .color-selection__image.readytoselect').removeClass('readytoselect');
        $('.color-selection__grid-item .color-selection__image').attr("aria-expanded", "false");
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('active');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().attr("aria-expanded", "true");
        updateCounter();

        if ($('color-switcher.color-selection__image.coladded').length > 0) {
          let colorNam = $('color-switcher.color-selection__image.coladded').last().attr('variant-name');
          $('.rosegold_heading p').html(`${colorNam} succesvol geselecteerd`);
        } else {
          $('.rosegold_inner').hide();
          $('.press_nail_inner').hide();
          // $('.design_combinations_inner').show();
        }

        if ($('.color-selection__grid-item.required-switcher:not(.coladded)').length <= 0) {
          $('.color-selection__grid-item.optional-switcher').show();
        } else if ($('.color-selection__grid-item.required-switcher:not(.coladded)').length > 0 && $('.color-selection__grid-item.optional-switcher.coladded').length <= 0) {
          $('.color-selection__grid-item.optional-switcher').first().hide();
        }
      
         if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
            updateColorDrawerSlider();
            colorSelectionSlider();
            // if ($(`color-switcher.color-selection__image.coladded[variant-id=${variantId}]`).length > 0) {
            //  $(`.color_selected_main .selected_item[variant-id=${variantId}]`).last().css('backgroundImage', `url(https://cdn.shopify.com/s/files/1/0522/4500/4475/files/new-nail-bg.png?v=1696294386)`);
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).last().removeClass('coladded');
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).last().removeAttr('variant-id');
            // } else {
            //    $(`.product-tile-item.active[data-variant=${variantId}]`).removeClass('active');
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).css('backgroundImage', `url(https://cdn.shopify.com/s/files/1/0522/4500/4475/files/new-nail-bg.png?v=1696294386)`);
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).removeClass('coladded');
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).removeAttr('variant-id');
            // }
          
          }
      
    });


$('body').on('click', '.product-tile-item .quantity_minus', function (evt) {
  let varID = $(this).closest('.product-tile-item').attr('data-variant');
  $(`color-switcher.color-selection__image.coladded[variant-id="${varID}"]`).last().find('.remove_item').click();
});

function updateColorDrawerSlider() {
    if ($('.color_selected_main .selected_item').length > 0) {
      $('.color_selected_main .selected_item').each(function () {
        const index = $(this).attr('data-index');
        if ($(`.color-selection__grid-item.coladded[data-count="${index}"]:not(.disabled-color)`) && $(`.color-selection__grid-item.coladded[data-count="${index}"] color-switcher.color-selection__image.coladded`).attr('variant-id')) {
          let imgURL = $(`.color-selection__grid-item.coladded[data-count="${index}"] color-switcher.color-selection__image.coladded`).attr('variant-img');
          let varID = $(`.color-selection__grid-item.coladded[data-count="${index}"] color-switcher.color-selection__image.coladded`).attr('variant-id');
          $(this).css('backgroundImage', `url(${imgURL})`);
          $(this).addClass('coladded');
          $(this).attr('variant-id', varID);
        } else {
          $(this).css('backgroundImage', `url(https://cdn.shopify.com/s/files/1/0522/4500/4475/files/new-nail-bg.png?v=1696294386)`);
          $(this).removeClass('coladded');
          $(this).removeAttr('variant-id');
        }
      })
    }
    if ($('color-switcher.color-selection__image.coladded').length > 0) {
      $('#color-choose-drawer .product-tile-item').removeClass('active');
      $('#color-choose-drawer .product-tile-item').find('input.quantity-selector__input').val(1);
      $('color-switcher.color-selection__image.coladded').each(function () {
        const varId = $(this).attr('variant-id');
        $(`#color-choose-drawer .product-tile-item[data-variant="${varId}"]`).addClass('active');
        $(`#color-choose-drawer .product-tile-item[data-variant="${varId}"]`).find('input.quantity-selector__input').val($(`color-switcher.color-selection__image.coladded[variant-id="${varId}"]`).length);
      })
    } else {
      $('#color-choose-drawer .product-tile-item').removeClass('active');
    }
    if ($('.color_selected_main .selected_item.coladded').length > 0) {
      $('.color_choose_guarantee_inner').addClass('active');
    } else {
      $('.color_choose_guarantee_inner').removeClass('active')
    }
    
    let freeColorCount = [];
    $('variant-metacolor input').each(function () {
      const val = parseInt($(this).attr('data-free-colors'), 10);
      if (!isNaN(val)) {
        freeColorCount.push(val);
      }
    });
    if (freeColorCount.length > 0) {
      freeColorCount.sort(function(a, b) {
        return a - b;
      });
    }
    
    if (freeColorCount[2] && ($(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-title').toLowerCase() == $('.block-swatch .block-swatch__radio:checked').attr('data-value').toLowerCase())) {
      if ($('color-switcher.color-selection__image.required-switcher.coladded').length >= freeColorCount[2]) {
        $('.color_selected_inner .selection_button').show();
      } else {
        $('.color_selected_inner .selection_button').hide();
      }
    } else if (freeColorCount[1] && ($(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-title').toLowerCase() == $('.block-swatch .block-swatch__radio:checked').attr('data-value').toLowerCase())) {
      if ($('color-switcher.color-selection__image.required-switcher.coladded').length >= freeColorCount[1]) {
        $('.color_selected_inner .selection_button').show();
      } else {
        $('.color_selected_inner .selection_button').hide();
      }
    } else {
      if ($('color-switcher.color-selection__image.required-switcher.coladded').length >= freeColorCount[0]) {
        $('.color_selected_inner .selection_button').show();
      } else {
        $('.color_selected_inner .selection_button').hide();
      }
    }
      
  
    if (freeColorCount[1] && $('.color_selected_main .selected_item.coladded').length == freeColorCount[0]) {
      const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-required-off');
      $('.product-item__label-list .label').hide();
      $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
      $('.product-item__label-list .percentOff').show();
    }

    if (freeColorCount[2] && $('.color_selected_main .selected_item.coladded').length >= freeColorCount[1]) {
      const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-required-off');
      $('.product-item__label-list .label').hide();
      $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
      $('.product-item__label-list .percentOff').show();
    }

    if (freeColorCount[0] && $('.color_selected_main .selected_item.coladded').length >= freeColorCount[0]) {
      const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[0]}"]`).attr('data-optional-off');
      $('.product-item__label-list .label').hide();
      $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
      $('.product-item__label-list .percentOff').show();
    }

    if ($('.color_selected_main .selected_item.coladded').length < freeColorCount[0]) {
      $('.product-item__label-list .percentOff').html('');
      $('.product-item__label-list .percentOff').hide();
      $('.product-item__label-list .label:not(.percentOff)').show();
    }
    
  }


$('.color_selected_inner .selection_button').on('click', function () {
  let freeColorCount = [];
  $('variant-metacolor input').each(function() {
    const val = parseInt($(this).attr('data-free-colors'), 10);
    if (!isNaN(val)) {
      freeColorCount.push(val);
    }
  });
  if (freeColorCount.length > 0) {
    freeColorCount.sort(function(a, b) {
      return a - b;
    });
  }

  for (let index = 0; index < freeColorCount.length; index++) {
    if (freeColorCount[index] == $('.color_selected_main .selected_item.coladded').length) {
      const varTitle = $(`variant-metacolor input[data-free-colors="${freeColorCount[index]}"]`).attr('data-title');
      $(`.block-swatch-list .block-swatch input[data-value="${varTitle}"]`).siblings('label.block-swatch__item').click();
    }
  }
  
  $('.popup-close.close-icon-popup').click();
})


    $('body').on('click', '#MainPaymentContainer', function(evt) {
        if ($(this).find('#AddToCart').attr('disabled') == 'disabled') {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            $('html, body').animate({
                scrollTop: $(".product__info form.shopify-product-form").offset().top - 50
            }, 10);
            setTimeout(() => {
                $('color-switcher.color-selection__image.required-switcher.readytoselect').trigger('click');
            }, 100);
        }
    });

//   document.addEventListener('click', (event) => {
//   const targetElement = event.target; 
//   // Now you can use targetElement to access properties and methods of the clicked element
//   console.log(targetElement); 
//     console.log(event); 
// });

    $('body').on('click', '.custom-new-upsell', function(evt) {
        if ($(this).find('.remover_upsell').attr('disabled') == 'disabled') {

            evt.preventDefault();
            evt.stopImmediatePropagation();
            $('color-switcher.color-selection__image.required-switcher.readytoselect').trigger('click');
        }
    });




    $('.color_choose_arrow').click(function() {
        let scroll = 100;
        if ($(this).hasClass('prev-arrow')) scroll *= -1;
        $('.color-filter-link-bar .link-bar__scroller').animate({
            scrollLeft: ($('.color-filter-link-bar .link-bar__scroller').scrollLeft() + scroll)
        }, 500);

    })


    $('.bullets-question_mark.Nagelkleber').click(function(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if ($(this).siblings('.Nagelkleber_content').is(":visible")) {
            $(this).text('?');
            $(this).siblings('.Nagelkleber_content').fadeOut();
        } else {
            $(this).text('x');
            $(this).siblings('.Nagelkleber_content').fadeIn();
        }

    })

    // $('whats-in-set#whats-in-set .product-tile-item').hover(

    //     function() { // Mouse enter function
    //         console.log('enter')
    //         $(this).find('.bullets-question_mark.Nagelkleber').text('x');
    //         $(this).find('.Nagelkleber_content').fadeIn();
    //     },
    //     function() { // Mouse leave function
    //         console.log('exit')
    //         $(this).find('.bullets-question_mark.Nagelkleber').text('?');
    //         $(this).find('.Nagelkleber_content').fadeOut();
    //     }
    // );

    // $("body").on('click', function(event) {
    //     if (!$(event.target).closest('color-choose-drawer#color-choose-drawer').length) {
    //         $('.color-selection__image').each(function(){
    //           $(this).closest('.color-selection__grid-item').removeClass('active');
    //           $(this).attr("aria-expanded", "false");
    //         })
    //         $('color-choose-drawer#color-choose-drawer').removeAttr('open');
    //         $('html').removeClass('lock-all');

    //     } 
    //   if (!$(event.target).closest('whats-in-set#whats-in-set').length){
    //     $('.whats-in-set[aria-controls="whats-in-set"]').attr("aria-expanded", "false"); 
    //       $('whats-in-set#whats-in-set').removeAttr('open');
    //     $('html').removeClass('lock-all');
    //   }
    // });


    $("color-choose-drawer#color-choose-drawer .popup-close").on('click', function(event) {
        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
        $('color-choose-drawer#color-choose-drawer').removeAttr('open');
        $('html').removeClass('lock-all');
    });

      $("color-choose-drawer#color-choose-drawer .drawer__overlay").on('click', function(event) {
        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
        $('color-choose-drawer#color-choose-drawer').removeAttr('open');
        $('html').removeClass('lock-all');
    });


    $("body").on(
        "click",
        ".products_filters_sortby .popout__toggle",
        function() {
            let $this = $(this);
            $(".products_filters_sortby .popout-list").slideToggle(function() {
                if ($(this).is(":visible")) {
                    $this.find(".down_close").css("transform", "rotate(180deg)");
                } else {
                    $this.find(".down_close").css("transform", "rotate(0deg)");
                }
            });
        }
    );

    $("body").on("click", "[data-sort-link]", function(evt) {
        evt.preventDefault();
        let valueSort = $(this).attr("data-value");
        let collectionHandle = $(this)
            .closest(".popout-list")
            .attr("data-collection");
        $(this).closest(".popout-list__item").addClass('active');
      $(this).closest(".popout-list__item").siblings().removeClass('active');
        $.ajax({
            url: `/collections/${collectionHandle}?view=set-bundle-sort&sort_by=${valueSort}`,
            type: "GET",
            success: function(response) {
                $('color-choose-drawer#color-choose-drawer').find(".products-tiles").html(response);
            },
            error: function(xhr, status, error) {
                // Handle any errors
                console.error("Error:", error);
            },
        });
    });

    // $(".option-popup .popup-inner .tags").slideDown();
    $("a.filters-pop").click(function(e) {
        e.preventDefault();

      if ($(".option-popup .popup-inner .tags").hasClass('active')) {
        $(".option-popup .popup-inner .tags").slideUp();
        $(".option-popup .popup-inner .tags").removeClass('active')
      } else {
        $(".option-popup .popup-inner .tags").slideDown();
        $(".option-popup .popup-inner .tags").addClass('active')
      }
        // $(".option-popup .popup-inner .tags").slideToggle();
        $(".sort-section").slideToggle();
        $(".search-area").slideUp();
    });

    $("a.search-pop").click(function(e) {
        e.preventDefault();
        $(".option-popup .popup-inner .tags").slideUp();
       $(".sort-section").slideUp();
        $(".search-area").slideToggle();
    });
  
    $(".tags-option1 .tag-wrapper").click(function() {
      if (!$(this).hasClass('disabled')) {
        var selectedTag1 = $(this).data("value");
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            selectedTag1 = null;
        } else {
            $(".tags-option1 .tag-wrapper").removeClass("active");
            $(this).addClass("active");
        }
        if (selectedTag1 == "all") {
          $("color-choose-drawer .product-tile-item").show();
          $('.tags-option2 .tag-wrapper').removeClass("active");
          $(this).addClass("active");
          return;
        }
        filterProductTiles(selectedTag1, getSelectedTag(".tags-option2"));
        updateDisabledStateNew(selectedTag1, "tags-option1");
        
      }
    });

    $(".tags-option2 .tag-wrapper").click(function() {
      if (!$(this).hasClass('disabled')) {
        var selectedTag2 = $(this).data("value");
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            selectedTag2 = null;
        } else {
            $(".tags-option2 .tag-wrapper").removeClass("active");
            $(this).addClass("active");
        }
        if (selectedTag2 == "all") {
          $("color-choose-drawer .product-tile-item").show();
          $('.tags-option2 .tag-wrapper').removeClass("active");
          $(this).addClass("active");
          return;
        }
        filterProductTiles(getSelectedTag(".tags-option1"), selectedTag2);
         updateDisabledStateNew(selectedTag2, "tags-option2");
      }
    });

    function getSelectedTag(selector) {
        return $(selector + " .tag-wrapper.active").data("value");
    }

    function filterProductTiles(tag1, tag2) {
        $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
            var classes = $(this).attr("class").split(" ");
            var formClass, langeClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i];
                } else if (classes[i].startsWith("plange_")) {
                    langeClass = classes[i];
                }
            }

            var showTile =
                (!tag1 || (formClass && formClass.split("_")[1] === tag1)) &&
                (!tag2 || (langeClass && langeClass.split("_")[1] === tag2));
            $(this).toggle(showTile);
        });
      
    }

    // function updateDisabledStateOld(tag1, tag2, option) {
    //     $(option + " .tag-wrapper").removeClass("disabled");
    //     if (tag1 || tag2) {
    //         $(option + " .tag-wrapper").each(function() {
    //             var selectedTag = $(this).data("value");
    //             if (option === ".tags-option1") {
    //                 if (!tag2 && tag1 !== selectedTag) {
    //                     $(this).addClass("disabled");
    //                 }
    //             } else {
    //                 if (!tag1 && tag2 !== selectedTag) {
    //                     $(this).addClass("disabled");
    //                 }
    //             }
    //         });
    //     }
    // }

    // function updateDisabledState(tag1, tag2, option) {
    //     var tilesWithTagsB = [];

    //     var visibleTiles = $("color-choose-drawer#color-choose-drawer .product-tile-item:visible");
    //     visibleTiles.each(function() {
    //         var classes = $(this).attr("class").split(" ");
    //         var langeClass;
    //         for (var i = 0; i < classes.length; i++) {
    //             if (classes[i].startsWith("plange_")) {
    //                 langeClass = classes[i].split("_")[1];
    //                 tilesWithTagsB.push(langeClass);
    //                 break;
    //             }
    //         }
    //     });

    //     $(option + " .tag-wrapper").removeClass("disabled");
    //     $(option + " .tag-wrapper").each(function() {
    //         var selectedTag = $(this).data("value");
    //         if (!tilesWithTagsB.includes(selectedTag)) {
    //             $(this).addClass("disabled");
    //         }
    //     });
    // }

    function updateDisabledStateNew(tag, option) {
        var tilesWithTagsA = [];
        var tilesWithTagsB = [];

        var visibleTiles = $("color-choose-drawer#color-choose-drawer .product-tile-item:visible");
        visibleTiles.each(function() {
            var classes = $(this).attr("class").split(" ");
            var langeClass;
            var formClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("plange_")) {
                    langeClass = classes[i].split("_")[1];
                    tilesWithTagsB.push(langeClass);
                }
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i].split("_")[1];
                    tilesWithTagsA.push(formClass);
                }
            }
        });

        $(".tags-option1 .tag-wrapper").removeClass("disabled");
      $(".tags-option2 .tag-wrapper").removeClass("disabled");
      
if (tag != null && option == 'tags-option1') {
  if ($(".tags-option2 .tag-wrapper.active").length == 0) {
        $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!tilesWithTagsB.includes(selectedTag) && selectedTag != "all") {
                $(this).addClass("disabled");
            }
        });
    
  } else {
    let dataVal = $(".tags-option1 .tag-wrapper.active").attr('data-value');
    let plangeArray = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.pform_${dataVal}`).each(function() {
      var classes = $(this).attr("class").split(" ");
            var langClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("plange_")) {
                    langClass = classes[i].split("_")[1];
                    plangeArray.push(langClass);
                }
            }
        });
    // console.log('plangeArray', plangeArray)
            $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!plangeArray.includes(selectedTag) && selectedTag != "all") {
                $(this).removeClass("active");
                $(this).addClass("disabled");
                // filterProductTiles(getSelectedTag(".tags-option1"), null);
            }
        });


    let dataVal2 = $(".tags-option2 .tag-wrapper.active").attr('data-value');
    let pformArray2 = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.plange_${dataVal2}`).each(function() {
      var classes2 = $(this).attr("class").split(" ");
            var formClass2;
            for (var i = 0; i < classes2.length; i++) {
                if (classes2[i].startsWith("pform_")) {
                    formClass2 = classes2[i].split("_")[1];
                    pformArray2.push(formClass2);
                }
            }
        });
        // console.log('pformArray2', pformArray2)
            $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!pformArray2.includes(selectedTag) && selectedTag != "all") {
                $(this).removeClass("active");
                $(this).addClass("disabled");
            }
        });


  }
}

  
if (tag != null && option == 'tags-option2') {      
  if ($(".tags-option1 .tag-wrapper.active").length == 0) {
            $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!tilesWithTagsA.includes(selectedTag) && selectedTag != "all") {
                $(this).addClass("disabled");
            }
        });
  } else {

        let dataVal = $(".tags-option2 .tag-wrapper.active").attr('data-value');
    let pformArray = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.plange_${dataVal}`).each(function() {
      var classes = $(this).attr("class").split(" ");
            var formClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i].split("_")[1];
                    pformArray.push(formClass);
                }
            }
        });
        // console.log('pformArray', pformArray)
            $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!pformArray.includes(selectedTag) && selectedTag != "all") {
                $(this).removeClass("active");
                $(this).addClass("disabled");
                // filterProductTiles(null, getSelectedTag(".tags-option2"));
            }
        });

        let dataVal1 = $(".tags-option1 .tag-wrapper.active").attr('data-value');
    let plangeArray1 = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.pform_${dataVal1}`).each(function() {
      var classes1 = $(this).attr("class").split(" ");
            var langClass1;
            for (var i = 0; i < classes1.length; i++) {
                if (classes1[i].startsWith("plange_")) {
                    langClass1 = classes1[i].split("_")[1];
                    plangeArray1.push(langClass1);
                }
            }
        });
    // console.log('plangeArray1', plangeArray1)
            $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!plangeArray1.includes(selectedTag) && selectedTag != "all") {
                $(this).removeClass("active");
                $(this).addClass("disabled");
            }
        });

    
    }
  }



  updateDisabledStateStart();
}


  updateDisabledStateStart();
  
    function updateDisabledStateStart() {
        var tilesWithTagsA = [];
        var tilesWithTagsB = [];

        var visibleTiles = $("color-choose-drawer#color-choose-drawer .product-tile-item");
        visibleTiles.each(function() {
            var classes = $(this).attr("class").split(" ");
            var langeClass;
            var formClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("plange_")) {
                    langeClass = classes[i].split("_")[1];
                    tilesWithTagsB.push(langeClass);
                }
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i].split("_")[1];
                    tilesWithTagsA.push(formClass);
                }
            }
        });

      // console.log(tilesWithTagsB)
      
        $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!tilesWithTagsA.includes(selectedTag) && selectedTag != "all") {
                $(this).addClass("disabled");
            }
        });

     
        $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).data("value");
            if (!tilesWithTagsB.includes(selectedTag) && selectedTag != "all") {
                $(this).addClass("disabled");
            }
        });

}
  

    $(".product-search").on("input", function() {
        var searchQuery = $(this).val().trim().toLowerCase();

        filterProductBySearch(searchQuery);
        toggleClearButton(searchQuery);
    });

    $(".clear-search-btn").on("click", function() {
        $(".product-search").val("").trigger("input").focus();
        $(this).hide();
    });

    function filterProductBySearch(searchQuery) {
        $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
            var productName = $(this).data("name");
            var keywords = $(this).data("keywords");
            if (productName) {
                productName = productName.toLowerCase();
                keywords = keywords.toLowerCase();
                var showTile = !searchQuery || productName.includes(searchQuery) || keywords.includes(searchQuery);
                $(this).toggle(showTile);
            }
        });
    }

    function toggleClearButton(searchQuery) {
        $(".clear-search-btn").toggle(searchQuery.length > 0);
    }

    $('#AddToCart').attr('disabled', 'true');
    $('#StickyAddToCart').addClass('disabled');
    $('#AddToCart .loader-button__text').text(window.translationsText.buttonUnfilled + ' 1');


});

/*po set coding */
if ($('.block-swatch-list .block-swatch').length > 0) {
    $(window).on('load', function() {
        // PoSetRefresh($('input[name="option1"]:checked').val());
       const firstOptionSelector = document.querySelector('.block-swatch-list .block-swatch .block-swatch__radio:checked');
        if (firstOptionSelector) {
          PoSetRefresh(firstOptionSelector.getAttribute('data-value'));
        }
    });
    document.addEventListener('variant:changed', function(event) {
        let variant = event.detail.variant;
        $('#AddToCart[data-product-add-to-cart-button]').attr('data-price', variant.price);
        PoSetRefresh(variant.title);
        setTimeout(() => {  
          colorSelectionSlider();
        }, 200);
    });
} else {
  let varTitle = $('.product-title__main').attr('data-variant-title');
  if (varTitle) {
    PoSetRefresh(varTitle);
  }
}

function PoSetRefresh(variant_title) {

 let variant_title_down = variant_title.toLowerCase();
 variant_title_down = variant_title_down.trim();
 variant_title_down = variant_title_down.replace(/[\s+]/g, "_");
  
  $(`.hide_on_other_variant`).hide();
    setTimeout(() => {
      $(`.show_${variant_title_down}`).show();
      $(`.show_all_variant`).show();
    }, 50);
  
    let allow_colors = $('.color-selection__grid-item').data('total-count');
    
    if (!(variant_title.indexOf('Premium') > -1) && !(variant_title.indexOf('5er') > -1) && !(variant_title.indexOf('premium') > -1)) {
        allow_colors = parseInt($('#pick-color-id').attr('basic-count'));
        $('.Basic_text').show();
        $('.Premium_text').hide();
        $('.starter-set-bp').show();
        $('.premium-set-bp').hide();
        $('.free_in_set_item').removeClass('coladded')
        if (!(variant_title.indexOf('Premium') > -1)) {
            $('.custom-new-upsell').parent().show();
        }
      
        // var count = parseInt($('.color-selection__grid-item.optional-switcher').first().data('count'));
        // var countTotalRequired = parseInt($('.color-selection__grid-item.required-switcher').first().data('total-count'));
        // var countTotalOptional = parseInt($('.color-selection__grid-item.optional-switcher').first().attr('data-optional-count'));
        //  $('.color-selection__grid-item.optional-switcher').each(function () {
        //   $(this).attr('data-total-count', countTotalOptional)
        // })

        // let optionalLength = $('.color-selection__grid-item.optional-switcher').length;
        //   let basicCount = parseInt($('#pick-color-id').attr('basic-count'));

        //   if (optionalLength < countTotalOptional && optionalLength >= basicCount + 1) {
        //         let counterArray = [];
        //           $('.color-selection__grid-item.optional-switcher.coladded').each(function () {
        //             counterArray.push(parseInt($(this).attr('data-count')));
                    
        //           })
        //         let currentCount = count;
        //           for (let cunt = countTotalRequired + 1; cunt <= countTotalOptional + countTotalRequired; cunt++) {
        //               if (!counterArray.includes(cunt)) {
        //                   currentCount = cunt;
        //                   break;
        //               }
        //           }
     
        //             let newItemHtml = `<div class="color-selection__grid-item optional-switcher" data-count="${currentCount}" data-optional-count="${countTotalOptional}" data-total-count="${countTotalOptional}">
        //              <span class="discounted_percent">-20%</span>
        //              <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${currentCount} readytoselect" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
        //                 <button class="remove_item">
        //                   <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        //                   <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
        //                   <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
        //                   </svg>
        //                 </button>
        //              </color-switcher>
        //              <div class="farbe-title">${window.translationsText.optionale}</div>
        //              <div class="farbe-vendor"></div>
        //              <div class="farbe-price_wrapper">
        //                 <div class="farbe-price"></div>
        //                 <div class="farbe-compare"></div>
        //              </div>
        //           </div>`;
        //       $('.color-selection__container .color-selection__grid').append(newItemHtml);
        //   }

      
    } else {
      
        $('.Basic_text').hide();
        $('.Premium_text').show();
        $('.starter-set-bp').hide();
        $('.premium-set-bp').show();
        $('.free_in_set_item').addClass('coladded')
        $('.remover_upsell').prop('checked', false);
        if ((variant_title.indexOf('Premium') > -1)) {
            $('.custom-new-upsell').parent().hide();
        }
      
      // var countTotalOptional = parseInt($('.color-selection__grid-item.optional-switcher').first().attr('data-optional-count'));
      // $('.color-selection__grid-item.optional-switcher').each(function () {
      //   if ($('body').hasClass('dip-pr-on-set-inventory-modified-byd-v1')) {
      //     $(this).attr('data-total-count', countTotalOptional - 2);
      //   } else {
      //     $(this).attr('data-total-count', countTotalOptional - 3);
      //   }
      // })



      //   let optionalLength = $('.color-selection__grid-item.optional-switcher').length;


      //   var count = parseInt($('.color-selection__grid-item.optional-switcher').first().data('count'));
      //   var countTotalRequired = parseInt($('.color-selection__grid-item.required-switcher').first().data('total-count'));

      //     let basicCount = parseInt($('#pick-color-id').attr('basic-count'));

      //     if (optionalLength < countTotalOptional - 2 && optionalLength >= basicCount + 1) {
      //           let counterArray = [];
      //             $('.color-selection__grid-item.optional-switcher.coladded').each(function () {
      //               counterArray.push(parseInt($(this).attr('data-count')));
                    
      //             })
      //           let currentCount = count;
      //             for (let cunt = countTotalRequired + 1; cunt <= countTotalOptional + countTotalRequired; cunt++) {
      //                 if (!counterArray.includes(cunt)) {
      //                     currentCount = cunt;
      //                     break;
      //                 }
      //             }
     
      //               let newItemHtml = `<div class="color-selection__grid-item optional-switcher" data-count="${currentCount}" data-optional-count="${countTotalOptional}" data-total-count="${countTotalOptional}">
      //                <span class="discounted_percent">-20%</span>
      //                <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${currentCount} readytoselect" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
      //                   <button class="remove_item">
      //                     <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      //                     <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
      //                     <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
      //                     </svg>
      //                   </button>
      //                </color-switcher>
      //                <div class="farbe-title">${window.translationsText.optionale}</div>
      //                <div class="farbe-vendor"></div>
      //                <div class="farbe-price_wrapper">
      //                   <div class="farbe-price"></div>
      //                   <div class="farbe-compare"></div>
      //                </div>
      //             </div>`;
      //         $('.color-selection__container .color-selection__grid').append(newItemHtml)
      //     }


    }



  
    // $('.set-no-color').text(allow_colors);
    // $('#pick-color-id').attr('custom-toshow', allow_colors);

    // $('.hidden-color[data-color-index]').each(function() {
    //     if (parseInt($(this).data('color-index')) > allow_colors) {
    //         $(this).val('');
    //         $(this).removeAttr('required');
    //         $(this).removeAttr('variant-id');
    //         $(this).removeAttr('variant-img');
    //     }
    // });

    // $('color-switcher.color-selection__image.required-switcher').each(function() {
    //     if (parseInt($(this).closest('.color-selection__grid-item').data('count')) > allow_colors) {

    //         $(this).closest('.color-selection__grid-item').removeClass('coladded');
    //         $(this).closest('.color-selection__grid-item').addClass('disabled-color');
    //         $(this).removeAttr('style');
    //         $(this).removeClass('coladded');
    //         $(this).removeClass('active');
    //         $(this).removeAttr('variant-name');
    //         $(this).removeAttr('variant-id');
    //         $(this).removeAttr('variant-img');
    //         $(this).siblings('.farbe-title').html(`${window.translationsText.design} ${$(this).closest('.color-selection__grid-item').data('count')}`);
    //         $(this).siblings('.farbe-vendor').html('');
    //         $(this).closest('.color-selection__grid-item').hide();
    //     } else {
    //         $(this).closest('.color-selection__grid-item').removeClass('disabled-color');
    //           $('.color-selection__grid-item.required-switcher').each(function () {
    //             if (!$(this).hasClass('coladded')) {
    //               let optionalItem = $('.color-selection__grid-item.optional-switcher.coladded').first();
                  
    //               if (optionalItem.length > 0) {         
                    
    //               $(this).find('color-switcher.color-selection__image.required-switcher').attr('variant-name', optionalItem.find('color-switcher.color-selection__image.optional-switcher').attr('variant-name'));
    //               $(this).find('color-switcher.color-selection__image.required-switcher').attr('variant-id', optionalItem.find('color-switcher.color-selection__image.optional-switcher').attr('variant-id'));
    //               $(this).find('color-switcher.color-selection__image.required-switcher').attr('variant-img', optionalItem.find('color-switcher.color-selection__image.optional-switcher').attr('variant-img'));
    //               $(this).find('color-switcher.color-selection__image.required-switcher').attr('style', optionalItem.find('color-switcher.color-selection__image.optional-switcher').attr('style'));
    //               $(this).find('.farbe-title').html(optionalItem.find('.farbe-title').html());
    //               $(this).find('.farbe-vendor').html(optionalItem.find('.farbe-vendor').html());
    //               $(this).addClass('coladded')
    //               $(this).find('color-switcher.color-selection__image.required-switcher').addClass('coladded')
    //               optionalItem.remove();
                    
    //               }
    //             }
    //           })
    //         $(this).closest('.color-selection__grid-item').show();
    //     }
    // })
      
      updateCounter();
  
}

function updateCounter() {
    setTimeout(() => {
        let selectedNo = parseInt($('.set-no-color_selected').first().text());
        let selectedTotal = parseInt($('.set-no-color').first().text());
        if (selectedNo == selectedTotal) {
            let totalColorsPrices = 0;
            $('#pick-color-id color-switcher.color-selection__image.required-switcher.coladded').each(function() {
                let price = parseInt($(this).attr('data-original-price'));
                totalColorsPrices += price;
            });

            $('.rosegold_text p').text('Ziet er geweldig uit! Je set is klaar!');
            $('.color-selection__label_text .unfilled').css('color', '#78A97C');
            let atcPriceOptional = 0;
            let atcPrice = parseInt($('[data-product-price-list] .price[data-price]').attr('data-price'));
            let atcPriceCompare = parseInt($('[data-product-price-list] .price[data-compare]').attr('data-compare'));
            if (totalColorsPrices != 0) {
              atcPriceCompare = totalColorsPrices + parseInt($('#pick-color-id').attr('data-included-accessories-prices'));
            }
            if ($('color-switcher.color-selection__image.optional-switcher.coladded').length > 0) {
                $('color-switcher.color-selection__image.optional-switcher.coladded').each(function() {
                    let optionalPrice = parseInt($(this).data('price'));
                    atcPrice += optionalPrice;
                    atcPriceOptional += optionalPrice;
                    let optionalPriceCompare = parseInt($(this).data('compare'));
                    atcPriceCompare += optionalPriceCompare;
                })
                $('#AddToCart[data-product-add-to-cart-button] .loader-button__text').html(`Toevoegen aan mandje | <span class="atc_copmare_btn">${window.globalMoneyFm(atcPriceCompare)}</span> <span class="atc_price_btn">${window.globalMoneyFm(atcPrice)}</span>`);
                $('[data-product-price-list] .price.price--highlight').html(`<span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${window.globalMoneyFm(atcPrice)}`);
                $('[data-product-price-list] .price.price--compare').html(`<span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${window.globalMoneyFm(atcPriceCompare)}`);
               $('.save_compare_price_dip').html(`${window.globalMoneyFm(atcPriceCompare-atcPrice)}`);
                
                var discountPercent = Math.round(((atcPriceCompare - atcPrice) / atcPriceCompare) * 100);
                $('.product__info .product-meta__price-list-container .label.label--highlight').html('-' + discountPercent + '%');
            } else {
                $('#AddToCart[data-product-add-to-cart-button] .loader-button__text').html(`Toevoegen aan mandje | <span class="atc_copmare_btn">${window.globalMoneyFm(atcPriceCompare)}</span> <span class="atc_price_btn">${window.globalMoneyFm(atcPrice)}</span>`);
                $('[data-product-price-list] .price.price--highlight').html(`<span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${window.globalMoneyFm(atcPrice)}`);
                $('[data-product-price-list] .price.price--compare').html(`<span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${window.globalMoneyFm(atcPriceCompare)}`);
               $('.save_compare_price_dip').html(`${window.globalMoneyFm(atcPriceCompare-atcPrice)}`);
                
                var discountPercent = Math.round(((atcPriceCompare - atcPrice) / atcPriceCompare) * 100);
                $('.product__info .product-meta__price-list-container .label.label--highlight').html('-' + discountPercent + '%');
            }
            $('#AddToCart[data-product-add-to-cart-button]').removeAttr('disabled');
            window.atcPrice = atcPriceOptional;
            window.atcPriceCompare = atcPriceCompare;
        } else {

            let atcPrice = parseInt($('[data-product-price-list] .price[data-price]').attr('data-price'));
            let atcPriceCompare = parseInt($('[data-product-price-list] .price[data-compare]').attr('data-compare'));
            if ($('color-switcher.color-selection__image.optional-switcher.coladded').length > 0) {
                $('color-switcher.color-selection__image.optional-switcher.coladded').each(function() {
                    let optionalPrice = parseInt($(this).data('price'));
                    atcPrice += optionalPrice;
                    let optionalPriceCompare = parseInt($(this).data('compare'));
                    atcPriceCompare += optionalPriceCompare;
                })
                $('[data-product-price-list] .price.price--highlight').html(`<span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${window.globalMoneyFm(atcPrice)}`);
                $('[data-product-price-list] .price.price--compare').html(`<span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${window.globalMoneyFm(atcPriceCompare)}`);
               $('.save_compare_price_dip').html(`${window.globalMoneyFm(atcPriceCompare-atcPrice)}`);
                
                var discountPercent = Math.round(((atcPriceCompare - atcPrice) / atcPriceCompare) * 100);
                $('.product__info .product-meta__price-list-container .label.label--highlight').html('-' + discountPercent + '%');
            } else {
                $('[data-product-price-list] .price.price--highlight').html(`<span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${window.globalMoneyFm(atcPrice)}`);
                $('[data-product-price-list] .price.price--compare').html(`<span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${window.globalMoneyFm(atcPriceCompare)}`);
                $('.save_compare_price_dip').html(`${window.globalMoneyFm(atcPriceCompare-atcPrice)}`);
                
                var discountPercent = Math.round(((atcPriceCompare - atcPrice) / atcPriceCompare) * 100);
                $('.product__info .product-meta__price-list-container .label.label--highlight').html('-' + discountPercent + '%');
            }

            $('.rosegold_text p').text('Geweldige look! Kies je volgende Design');
            $('.color-selection__label_text .unfilled').css('color', '#272727')
            $('#AddToCart .loader-button__text').text(`${window.translationsText.buttonUnfilled}`);
            $('.color-selection__grid-item:not(.disabled-color) .color-selection__image.readytoselect').removeClass('readytoselect');
            $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
            $('#AddToCart[data-product-add-to-cart-button]').attr('disabled', 'true');
        }

                  let optionalLengthNotSelected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
      // console.log(optionalLengthNotSelected)
        if (optionalLengthNotSelected > 1) {
          $('.color-selection__grid-item.optional-switcher:not(.coladded)').each(function (index) {
            if (index > 0) {
              $(this).remove();
            } else {
              let foundNotSelected = false;
              $('.color-selection__grid-item.required-switcher').each(function () {
                if (!$(this).hasClass('coladded') && !$(this).hasClass('disabled-color')) {
                  foundNotSelected = true;
                } else {
                  $(this).find('color-switcher.color-selection__image').removeClass('readytoselect')
                }
              })
              if (!foundNotSelected) {
                $(this).find('color-switcher.color-selection__image.optional-switcher:not(.coladded)').addClass('readytoselect')
              }
              
            }
           
          })
        } else {
              let foundNotSelected = false;
              $('.color-selection__grid-item.required-switcher').each(function () {
                if (!$(this).hasClass('coladded') && !$(this).hasClass('disabled-color')) {
                  foundNotSelected = true;
                } else {
                  $(this).find('color-switcher.color-selection__image').removeClass('readytoselect')
                }
              })
              if (!foundNotSelected) {
                $('color-switcher.color-selection__image.optional-switcher:not(.coladded)').addClass('readytoselect')
              }
          
        }

      
    }, 200);
}


function colorSelectionSlider() {
  const girdSlider = document.querySelector('.color-selection__grid.selection_grid_slider');
  if (!girdSlider) return;
  /* Sentry 2026-09-19 (NL-45): Flickity kommt aus dem defer-Bundle - fehlt es beim Aufruf (oder blieb es aus), nach dem
     Laden erneut versuchen statt zu werfen; das Raster bleibt bis dahin ohne Slider bedienbar */
  if (typeof Flickity === 'undefined') {
    if (!colorSelectionSlider.dnWartet) {
      colorSelectionSlider.dnWartet = true;
      window.addEventListener('load', function () { colorSelectionSlider.dnWartet = false; colorSelectionSlider(); }, { once: true });
    }
    return;
  }
  
  // If already initialized, destroy before re-initializing
  const existing = Flickity.data(girdSlider);
  if (existing) {
    existing.destroy();
  }

  const girdSliderFlkty = new Flickity(girdSlider, {
    pageDots: false,
    cellAlign: "left",
    contain: true,
    wrapAround: false,
    prevNextButtons: false,
    draggable: true,
    fade: false,
  });

  setTimeout(() => {
    const activeIndex = girdSliderFlkty.cells.findIndex((cell) =>
      cell.element.classList.contains('is-active')
    );
    if (activeIndex > -1) {
      girdSliderFlkty.select(activeIndex, false, true);
    }
  }, 20);
}

colorSelectionSlider();

$(document).ready(function() {

  // $('.block-swatch.custom-po-set.variant_2-2-gratis-ontwerpen label').click();

  
document.addEventListener("doc:rerendered", (event) => {
  updateCounter();
})

  
    $(".shopify-section-custom_accordion .collapsible-toggle").click(function(event) {
        event.preventDefault();
        let clickedEle = $(this);
        let ariaExp = clickedEle.attr('aria-expanded')
        $(this).addClass('clicked')
        $(".shopify-section-custom_accordion .collapsible-toggle:not(.clicked)").each(function() {
            $(this).attr('aria-expanded', 'false');
            $(this).siblings('collapsible-content').removeAttr('open');
        })

        if (ariaExp != 'false') {
            $(this).removeClass('clicked')
        }

    });
});

